<template>
  <div class="lists">
    <div v-if="listData.data && listData.data.length !== 0" class="text-center">
      <ul class="text-center lists-content">
        <li
          v-for="list in listData.data[listData.page]"
          :key="list.id"
          @click="
            link(
              {
                type: 'info',
                link: '/info',
                category: list.category_id,
                id: list.id
              },
              'windowOpen'
            )
          "
        >
          <i class="s-circular"></i>
          <span class="al-content"> {{ list.title || '暂无数据' }} </span>
          <span class="float-right"
            >收藏于
            {{
              list.pivot && list.pivot.created_at
                ? dateFilter(list.pivot.created_at, '/')
                : ''
            }}</span
          >
        </li>
      </ul>
    </div>
    <div v-else class="text-center no-data">暂无数据</div>
    <div class="pag text-center">
      <paginate
        class="clearfix"
        v-model="listData.page"
        :page-count="listData.pageCount"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="''"
        :next-text="''"
        prev-class="page-prev"
        next-class="page-next"
        :container-class="'pagination'"
        :page-class="'page-item'"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import dateFilter from '@/core/mixins/dateFilter'
import paginateFilter from '@/core/mixins/paginateFilter'
export default {
  name: 'article-collections',
  mixins: [dateFilter, link, paginateFilter],
  data() {
    return {
      listData: {
        data: [],
        total: 0, // 总数
        page: 1, // 第几页
        pageSize: 6, //每页条数
        pageCount: 0
      }
    }
  },
  computed: {
    articlesCollections() {
      let data = this.$store.getters['SubscriberStore/articlesCollections']
      return data
    }
  },
  watch: {
    articlesCollections() {
      this.getListData()
    }
  },
  mounted: function() {
    this.getListData()
  },
  methods: {
    clickCallback(pageNum) {
      document.body.scrollIntoView()
      this.listData.page = pageNum
      this.getListData()
    },
    getListData() {
      if (!this.articlesCollections) {
        return
      }
      this.listData.data = this.articlesCollections
      this.listData = this.paginateFilter(this.listData)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.lists {
  min-height: 200px;
  .lists-content {
    border-top: 2px solid $c-list-border;
    min-height: 200px;

    > li {
      padding-left: 20px;
      position: relative;
      .s-circular {
        position: absolute;
        top: 26px;
        left: 0;
      }
    }
  }
}
.al-content {
  width: 84% !important;
}
</style>
